import { AnimatePresence, motion } from 'framer-motion'
import * as Dialog from '@radix-ui/react-dialog'
import { Content, Overlay, StyledClose, StyledCloseIcon } from './Modal.styles'
import type { ModalProps } from './Modal.types'

export const Modal = ({
  className = '',
  children,
  open,
  // eslint-disable-next-line @typescript-eslint/unbound-method
  onOpenChange,
}: ModalProps): JSX.Element => {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <AnimatePresence>
        {open && (
          <Dialog.Portal forceMount>
            <Dialog.Overlay asChild>
              <Overlay
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2, ease: 'easeInOut' }}
              />
            </Dialog.Overlay>
            <Dialog.Content asChild>
              <Content className={className}>
                <StyledClose>
                  <StyledCloseIcon width={24} height={24} />
                </StyledClose>
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.2, ease: 'easeInOut' }}
                >
                  {children}
                </motion.div>
              </Content>
            </Dialog.Content>
          </Dialog.Portal>
        )}
      </AnimatePresence>
    </Dialog.Root>
  )
}
